import React, { useContext, useState } from "react";
import styled from "styled-components";
import intl from "react-intl-universal";
import commonUtils from "../../../script/utils/commonUtils";
import { mdiContentSave } from "@mdi/js";

import userRest from "../../../rest/userRest";

import { SettingsItem } from "./SettingsItem";
import { Button } from "../../components/Button";
import { Spacer } from "../../components/Spacer";
import { InputText } from "../../components/InputText";
import { ValidationContext } from "../../contexts/ValidationContext";

import { useInput } from "../../hooks/useInput";
import { useValidation } from "../../hooks/useValidation";

const SaveStyle = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const PasswordSettings = () => {

    const validationContext = useContext(ValidationContext);

    const [saving, setSaving] = useState(false);
    const passwordOld = useInput("passwordOld", null);
    const passwordNew = useInput("passwordNew", null);
    const passwordRepeat = useInput("passwordRepeat", null);

    useValidation(async value => {
        if (commonUtils.isBlank(value)) {
            return intl.get("settings.password.error.presence");
        }
        const valid = await userRest.checkPassword(value);
        if (!valid) {
            return intl.get("settings.password.error.previous");
        }
        return true;
    }, [passwordOld]);

    useValidation(value => {
        if (commonUtils.isBlank(value)) {
            return intl.get("settings.password.error.presence");
        }
        if (value.length < 8) {
            return intl.get("settings.password.error.length");
        }
        if (!value.match(/((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$&@?<>~!%#]).{8,20})/)) {
            return intl.get("settings.password.error.strength");
        }
        return true;
    }, [passwordNew]);

    useValidation(value => {
        if (commonUtils.isBlank(value)) {
            return intl.get("settings.password.error.presence");
        }
        if (value !== passwordNew.value) {
            return intl.get("settings.password.error.repeat");
        }
        return true;
    }, [passwordRepeat]);

    const onSave = async () => {
        setSaving(true);
        const allValid = await validationContext.allValid();
        validationContext.setErrorsVisible(true);
        if (allValid) {
            await userRest.changePassword(passwordOld.value, passwordNew.value);
            passwordOld.set("");
            passwordNew.set("");
            passwordRepeat.set("");
            validationContext.setErrorsVisible(false);
        }
        setSaving(false);
    };

    return (
        <SettingsItem title={intl.get("settings.password.title")} >
            <InputText {...passwordOld.bind}
                password
                maxLength="50"
                title={intl.get("settings.password.old")} />
            <Spacer variant="horizontal" />
            <InputText {...passwordNew.bind}
                password
                maxLength="50"
                type="password"
                title={intl.get("settings.password.new")} />
            <Spacer variant="horizontal" />
            <InputText {...passwordRepeat.bind}
                password
                maxLength="50"
                type="password"
                title={intl.get("settings.password.repeat")} />
            <Spacer variant="horizontal" />
            <SaveStyle>
                <Button
                    svgIcon={mdiContentSave}
                    loading={saving}
                    onClick={() => onSave()}
                    value={intl.get("common.save")} />
            </SaveStyle>
            <Spacer variant="horizontal" />
        </SettingsItem>
    );
};